import {oldSupportInfoClient, SupportInfo} from 'common/report/queries/app-api/support-info-client';

import {Store} from './store';

export const supportInfoStore = new Store<SupportInfo>({
  apiClient: oldSupportInfoClient,
  defaultValue: {},
  name: `support-info`,
});
